module.exports = __webpack_public_path__ + "img/fallback_drug_picture.6b918186.jpg";